import { AnalyticsManager } from './AnalyticsManager'

export { AnalyticsManager }
